var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 581 581",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 82 515 C 83 529 73 541 59 543 45 545 32 537 29 523 26 504 22 484 23 464 25 323 78 206 189 116 238 75 297 53 361 44 420 36 478 43 535 57 552 62 560 75 556 91 553 105 539 113 523 109 517 107 515 108 514 115 494 227 474 338 454 451 451 465 447 469 432 471 332 481 231 491 130 501 114 503 98 505 81 507 81 510 82 512 82 515 Z M 87 471 C 139 465 193 460 245 454 301 449 357 443 414 438 419 437 420 435 421 431 422 423 424 415 426 407 440 324 455 242 469 160 473 141 477 121 480 99 460 97 441 95 421 94 363 92 308 105 257 134 198 168 156 217 123 276 98 323 83 374 77 427 76 441 77 456 77 471 81 471 84 471 87 471 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFender);
export default __webpack_public_path__ + "static/media/fender.316b8165ba1ff2c7fa7a39d8f0f046b4.svg";
export { ForwardRef as ReactComponent };